import { alpha } from '@mui/material/styles';
export default function IconButton(theme) {
    return {
        MuiIconButton: {
            defaultProps: {
                color: 'default'
            },
            styleOverrides: {
                root: ({ ownerState, theme }) => {
                    // Set base color and borderColor based on color prop
                    let baseColor = theme.palette.action.selected;
                    let borderColor = theme.palette.action.selected;
                    let iconColor = undefined;
                    if (ownerState.color && theme.palette[ownerState.color]) {
                        baseColor = theme.palette[ownerState.color].main;
                        borderColor = alpha(theme.palette[ownerState.color].main, 0.12);
                        iconColor = theme.palette[ownerState.color].main;
                    }
                    if (ownerState.color === 'inherit') {
                        iconColor = 'inherit';
                    }
                    // Set borderRadius based on size
                    let borderRadius = theme.spacing(1.75);
                    if (ownerState.size === 'small') {
                        borderRadius = theme.spacing(1.75);
                    }
                    else if (ownerState.size === 'Xs') {
                        borderRadius = theme.spacing(1.75);
                    }
                    return {
                        borderRadius,
                        border: '1px solid',
                        borderColor,
                        color: iconColor,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        verticalAlign: 'middle',
                        '& .MuiTouchRipple-root .MuiTouchRipple-child': {
                            borderRadius
                        },
                        '&:hover': {
                            backgroundColor: alpha(baseColor, 0.08)
                        }
                    };
                },
                sizeLarge: {
                    width: '48px',
                    height: '48px',
                    fontSize: '32px'
                },
                sizeMedium: {
                    width: '40px',
                    height: '40px',
                    fontSize: '24px'
                },
                sizeSmall: {
                    width: '36px',
                    height: '36px',
                    fontSize: '20px'
                },
                sizeXs: {
                    width: '32px',
                    height: '32px',
                    fontSize: '18px'
                }
            }
        }
    };
}
